// extracted by mini-css-extract-plugin
export default {"suggestionButton":"SuggestionToolbar_suggestionButton__jwwmj"};